import styled from "styled-components";
import { color, typeStyle, units, visuallyHidden } from "@m/alchemy-theme";
import { Input } from "../input/Input";
import { StyledCalendarButton } from "../date-picker/CalendarButton";
export const DateCalendar = styled.div `
  position: relative;
  display: inline-block;
  min-width: 288px;
  user-select: none;
  z-index: 0;
  /****************************************************
  react-day-picker styles
  STYLES TAKEN FROM: react-day-picker/dist/style.css";
  with a few updates
  ***************************************************/
  --rdp-cell-size: 40px;
  --rdp-accent-color: ${color("base", { palette: "expressiveInformative" })};
  --rdp-background-color: transparent;
  /* Switch to dark colors for dark themes */
  --rdp-accent-color-dark: ${color("base", { palette: "expressiveInformative" })};
  --rdp-background-color-dark: ${color("base", { palette: "expressiveInformative" })};
  /* Outline border for focused elements */
  --rdp-outline: 2px solid var(--rdp-accent-color);
  /* Outline border for focused and selected elements */
  --rdp-outline-selected: 2px solid rgba(0, 0, 0, 0.75);

  .rdp {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 16px ${(props) => (props.isInline ? 0 : "20px")};
  }

  .rdp-months {
    position: relative;
    display: flex;
    justify-content: center;
    column-gap: 16px;
    row-gap: 16px;
    flex-wrap: wrap;
    max-width: 100%;
  }

  .rdp-day {
    height: 100%;
    width: 40px;
    border-radius: 50%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* Hide elements for devices that are not screen readers */
  .rdp-vhidden {
    ${visuallyHidden()}
  }

  /* Buttons */
  .rdp-button_reset {
    appearance: none;
    position: relative;
    margin: 0;
    padding: 0;
    cursor: default;
    color: inherit;

    background: none;
    font: inherit;

    -moz-appearance: none;
    -webkit-appearance: none;
  }

  .rdp-button {
    border: none;
    overflow: visible;
    cursor: pointer;
  }

  .rdp-day_disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  [disabled],
  [aria-disabled="true"] {
    pointer-events: none;
  }

  .rdp-day {
    &:before,
    &:after {
      z-index: -1;
      position: absolute;
      content: " ";
      height: 35px;
      width: 35px;
      transition:
        background-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }

    &:active {
      font-weight: bold;
    }

    &:before {
      width: 100%;
      top: 2.5px;
      left: 0;
    }

    &:after {
      position: absolute;
      top: 2.5px;
      left: 2.5px;
      border-radius: 50%;
    }

    &:hover,
    [data-whatinput="keyboard"] &:focus {
      font-weight: bold;

      outline: none;
      &:after {
        box-shadow: 0px 0px 0px 2px #2e77d0;
      }
    }
  }

  .rdp-day_range_middle,
  .rdp-day_range_start,
  .rdp-day_range_end {
    &:before {
      background-color: ${color("hint", { palette: "interactiveConstructive" })};
    }
  }

  .rdp-day_range_end {
    &:before {
      width: 50%;
      right: 50%;
    }
  }

  .rdp-day_range_start {
    &:before {
      width: 50%;
      left: 50%;
    }
  }

  .rdp-day_today:not(.rdp-day_selected) {
    color: var(--rdp-accent-color);
    font-weight: bold;
  }

  .rdp-day_selected:not(.rdp-day_range_middle),
  .rdp-day_range_start,
  .rdp-day_range_end {
    color: ${color("inverse")};

    &:active,
    [data-whatinput="keyboard"] &:focus {
      font-weight: bold;
    }

    &:after {
      z-index: -1;
      content: " ";
      height: 35px;
      width: 35px;
      position: absolute;
      top: 2.5px;
      left: 2.5px;
      background-color: ${color("base", { palette: "expressiveInformative" })};
      border-radius: 50%;
    }

    &:hover,
    [data-whatinput="keyboard"] &:focus,
    &.rdp-day_focused {
      &:after {
        box-shadow:
          0px 0px 0px 2px #2e77d0,
          inset 0px 0px 0px 2px #ffffff;
      }
    }
  }

  .rdp-day_range_start.rdp-day_range_end {
    &:before {
      background: transparent;
    }
  }

  .rdp-head_cell {
    vertical-align: middle;
    text-transform: capitalize;
    color: ${color("typeSubHeader")};
    ${typeStyle("labelM")}
    text-align: center;
  }

  .rdp-cell {
    position: relative;
    width: var(--rdp-cell-size);
    height: var(--rdp-cell-size);
    padding: 0;
    text-align: center;
    vertical-align: center;
    border: none;
    ${typeStyle("bodyL")};
  }

  .rdp-table {
    margin: 0;
    max-width: calc(var(--rdp-cell-size) * 7);
    border-collapse: collapse;

    td,
    th {
      padding: 0;
      height: var(--rdp-cell-size);
      width: var(--rdp-cell-size);
    }
  }
`;
export const DateInput = styled(Input) `
  ${StyledCalendarButton} {
    position: absolute;
    right: ${units(1.75)};
    top: ${units(1)};
  }

  input {
    min-width: 100px;
    padding-right: ${units(4)};
  }
`;
export const WeekNumber = styled.div `
  white-space: pre;
`;
